<app-filter-panel [fields]="fieldsConfig" [quickSearchFilter]="filters.code" quickSearchPlaceholder="Código" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
    <span class="w-full input-field p-input-icon-right">
        <input pInputText placeholder="Código" [(ngModel)]="filters.code.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.code.value" class="pi pi-times cursor-pointer"
            (click)="filters.code.value = null; search()"></i>
    </span>
    <div class="input-field" style="width: 50%;">
        <p-dropdown [placeholder]="thirdPartyName" [options]="thirdParties" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.thirdPartyId.value" (onChange)="search()" showClear />
    </div>
    <div class="input-field" style="width: 50%;">
        <p-dropdown placeholder="Estado" [options]="transactionStates" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.transactionStateId.value" (onChange)="search()" showClear /> 
    </div>
    <div class="input-field" style="width: 50%;">
        <p-dropdown placeholder="Sociedad" [options]="business" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.businessId.value" (onChange)="search()" showClear /> 
    </div>
    <div class="input-field" style="width: 50%;">        
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filtersDate.dateFrom" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body" (onSelect)="search()"
            (onClear)="search()" placeholder="Desde"></p-calendar>
    </div>
    <div class="input-field" style="width: 50%;">        
        <p-calendar [firstDayOfWeek]="1" [(ngModel)]="filtersDate.dateTo" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
            [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body" (onSelect)="search()"
            (onClear)="search()" placeholder="Hasta"></p-calendar>
    </div>
</div>
-->

<p-table #grid [value]="transactions" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body"
    [(selection)]="selectedRowsIds" dataKey="id">
    <ng-template pTemplate="header" let-columns>
        <tr>                        
            <th style="width: 4rem" *ngIf="allowRowSelection"><p-tableHeaderCheckbox /></th>
            <th pSortableColumn="code">Código <p-sortIcon field="code"></p-sortIcon></th>
            <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>                           
            <th pSortableColumn="thirdPartyId" *ngIf="transactionType.thirdPartyType != null">{{transactionType.thirdPartyType == "Client"?"Cliente":
                transactionType.thirdPartyType == "Company"?"Compañía":
                transactionType.thirdPartyType == "Provider"?"Proveedor":"Operario"}} <p-sortIcon field="thirdPartyId"></p-sortIcon></th>  
            <th pSortableColumn="business.name">Sociedad <p-sortIcon field="business.name"></p-sortIcon></th>    
            <th pSortableColumn="workRetention">Retención <p-sortIcon field="workRetention"></p-sortIcon></th>                           
            <th pSortableColumn="workRetentionDate">Fecha retención <p-sortIcon field="workRetentionDate"></p-sortIcon></th>   
            <th width="100"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-transaction let-columns="columns">
        <tr (dblclick)="edit(transaction)">                        
            <td *ngIf="allowRowSelection">
                <p-tableCheckbox [value]="transaction" *ngIf="!transaction.transactionState?.isFinal"/>
            </td>
            <td>{{transaction.code}}</td>
            <td>{{transaction.date | date:'dd/MM/yy'}}</td>                        
            <td>
                <div *ngIf="transactionType.thirdPartyType != null">
                    <app-deleted-label [resource]="transaction.thirdParty"></app-deleted-label>
                </div>                
            </td>
            <td>{{transaction.business?.name}}</td>                                          
            <td>{{transaction.workRetention | currency:'EUR'}}</td>
            <td>{{transaction.workRetentionDate | date:'dd/MM/yy'}}</td> 
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowWrite && transaction.workRetentionDate && canBeInvoiced(transaction)" 
                        (click)="generateWorkRetention(transaction)" [rounded]="true" label="Facturar"
                        ><i class="pi pi-money-bill"></i></p-button>                 
                    <p-button *ngIf="allowDelete" (click)="delete(transaction)" [rounded]="true" [text]="false"
                        severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="edit(transaction)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="allowRowSelection?9:8" class="text-center">        
             No se ha encontrado transacciones
          </td>
        </tr>
      </ng-template>
</p-table>

<p-dialog header="Factura de retención de obra" [(visible)]="displayRetentionModal" [modal]="true" [closable]="false"
    [style]="{width: '500px'}">
    <div class="grid">
        <div class="col-6 input-field">
            <label for="date">Fecha</label>
            <p-calendar [firstDayOfWeek]="1" id="date" [(ngModel)]="workRetention.date" [showIcon]="true" [showButtonBar]="true"
                [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error
                appendTo="body"></p-calendar>
        </div>        
        <div class="col-6 input-field">
            <label for="total">Importe</label>
            <input pInputText type="text" value="{{ workRetention.total | currency:'EUR':'symbol':'1.2-2' }}" disabled>
        </div>
        <div class="col-12 input-field">
            <label for="description">Notas</label>
            <textarea pInputTextarea [(ngModel)]="workRetention.notes" style="field-sizing: content;"
                d-form-field-error rows="3"></textarea>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="displayRetentionModal=false"></button>
        <button pButton label="Guardar" icon="pi pi-check" (click)="saveWorkRentention()"></button>
    </ng-template>
</p-dialog>


<p-confirmDialog></p-confirmDialog>